export default __webpack_public_path__ + "static/media/timelineOpportunityUnarchived.661b4bac.svg";